<template>
  <b-col v-if="Object.keys(item).length" class="">
    <b-row>
      <b-col cols="12">
        <headerPdf title="اطلاعات تماس" />
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="renderedItem.mobiles.length" cols="12">
        <label for="" class="title_style">{{ $lang.mobileNumber }}</label>
        <p v-for="(mobile, index) in renderedItem.mobiles" :key="index">
          {{ mobile }}
        </p>
      </b-col>
      <b-col v-if="renderedItem.email" cols="12">
        <eachItemPdf
          :title="$lang.email_address"
          :subTitle="renderedItem.email"
        />
      </b-col>
      <b-col v-if="renderedItem.homePhone" cols="3">
        <eachItemPdf
          :title="$lang.home_number"
          :subTitle="renderedItem.homePhone"
        />
      </b-col>
      <b-col v-if="renderedItem.workPhone" cols="3">
        <eachItemPdf
          :title="$lang.workplace_number"
          :subTitle="renderedItem.workPhone"
        />
      </b-col>
      <b-col v-if="renderedItem.messenger" cols="3">
        <eachItemPdf
          :title="$lang.social_messenger"
          :subTitle="renderedItem.messenger"
        />
      </b-col>
      <b-col v-if="renderedItem.site" cols="3">
        <eachItemPdf :title="$lang.website" :subTitle="renderedItem.site" />
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import eachItemPdf from "../eachItemPdf.vue";
import { pathOr } from "ramda";

export default {
  name: "Contact",
  components: {
    headerPdf,
    eachItemPdf,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    renderedItem() {
      return {
        mobiles: pathOr([], ["mobile"], this.item),
        email: pathOr(null, ["email"], this.item),
        homePhone: pathOr(null, ["home_phone"], this.item),
        workPhone: pathOr(null, ["work_phone"], this.item),
        messenger: pathOr(null, ["messenger"], this.item),
        site: pathOr(null, ["site"], this.item),
      };
    },
  },
  methods: {
    pathOr,
  },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}
</style>
